import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock } from 'react-icons/ci';

const VehicleDocumentType = () => {
    useDocumentTitle("Vehicle Document Type | T360");

    const { settingChild } = useContext(UserContext);
    const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
    const [vehicleDocTypeModel, setVehicleDocTypeModel] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [vehicleDocList, setVehicleDocList] = useState([])
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const prevFilterRef = useRef();
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        // status: 1
    });

    const toggleVehicleDocTypeModel = () => {
        setVehicleDocTypeModel(!vehicleDocTypeModel);
    };

    const getDataVehicleDocTypeList = async () => {
        try {
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
            }
            const res = await getVehicleDocTypeListData(object);
            if (res?.responseCode == 200) {
                setVehicleDocList(res?.data?.docTypes);
                setTotalItems(res?.data?.total_count);
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {

        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDataVehicleDocTypeList();
            prevFilterRef.current = filter;
        }

    }, [filter, vehicleDocTypeModel])

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteVehicleDocType = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: isDelete?.company_id,
                id: isDelete?._id,
            }
            const res = await deleteVehicleDocData(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getDataVehicleDocTypeList();
                setLoading(false);
                setIsDelete(false);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteVehicleDocType,
        isLoadding: loading,
    }

    let vehicleDocTypeModelProps = {
        isOpen: vehicleDocTypeModel,
        closeModal: (e) => setVehicleDocTypeModel(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: vehicleDocTypeModel?.isDetails ? "View Document Type" : (vehicleDocTypeModel?._id ? 'Update Document Type' : 'Add Document Type'),
        submitTitle: vehicleDocTypeModel?.isDetails ? "View Document Type" : (vehicleDocTypeModel?._id ? 'Update Document Type' : 'Add Document Type'),
        footerPart: vehicleDocTypeModel?.isDetails ? true : false,
        hideFooterSumbmitBtn: vehicleDocTypeModel?.isDetails ? true : false,
        hideCompletelyFoolter: vehicleDocTypeModel?.isDetails ? true : false,
        ApiCall: getDataVehicleDocTypeList
    }

    const columns = [
        { header: "Document Type", accessor: "document_type" },
        { header: "Number of Document", accessor: "number_of_document" },
        { header: "Action", accessor: "action" }
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
            // serial: <>
            //     <div className="signDropdown">
            //         <button className="dropbtn11">
            //             <BsThreeDotsVertical />
            //         </button>
            //         <div className="dropdownContent">
            //             {settingChildVehicleGrp?.view === 1 && <div onClick={(e) => setVehicleDocTypeModel({ ...item, isDetails: true })}
            //                 className='_avPointer'
            //                 style={{ textDecoration: 'none' }}

            //             >
            //                 <span className='_samAnchor'>
            //                     <span className='viewIcon_avt'>
            //                         <AiOutlineEye />
            //                     </span>View
            //                 </span>
            //             </div>}

            //             {settingChildVehicleGrp?.edit === 1 && <div
            //                 // onClick={(e) => editHandler(item)}
            //                 className='_avPointer'
            //             >
            //                 <span className='_samAnchor'>
            //                     <span className='editIcon_avt'>
            //                         <FiEdit />
            //                     </span>
            //                     Edit
            //                 </span>
            //             </div>}

            //             {settingChildVehicleGrp?.delete === 1 && <div
            //                 onClick={(e) => deleteHandler(item)}
            //                 className='_avPointer'
            //             >
            //                 <span className='_samAnchor'>
            //                     <span className='deleteIcon_avt'>
            //                         <FaRegTrashCan color='red' />
            //                     </span>
            //                     Delete
            //                 </span>
            //             </div>}
            //         </div>
            //     </div>
            // </>,
            document_type: <span className='_tblText _style_ancer' onClick={(e) => setVehicleDocTypeModel({ ...item, isDetails: true })}>
                <a className='_avPointer'>
                    {item?.name ? item?.name : '-'} &nbsp;
                </a>
                {item?.is_locked && <span className='_samAnchor'>
                    <span className='editIcon_avt'>
                        <CiLock color="red" size={20} />
                    </span>
                </span>}
            </span>,
            number_of_document: <>{item?.number_of_doc > 0 ? item?.number_of_doc : '-'}</>,
            action: (
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "100px" }}
                >
                    {/* {settingChildVehicleGrp?.view === 1 &&  */}
                    {/* <div onClick={(e) => setVehicleDocTypeModel({ ...item, isDetails: true })}
                        className='_avPointer'
                        style={{ textDecoration: 'none' }}
                    >
                        <span className='_samAnchor'>
                            <span className='viewIcon_avt'>
                                <AiOutlineEye color='green' />
                            </span>
                        </span>
                    </div> */}
                    {/* // } */}

                    {/* {settingChildVehicleGrp?.edit === 1 &&  */}
                    <div
                        onClick={(e) => setVehicleDocTypeModel(item)}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color='blue' />
                            </span>
                        </span>
                    </div>
                    {/* } */}

                    {/* {settingChildVehicleGrp?.delete === 1 &&  */}
                    {!item?.is_locked ? <div
                        onClick={(e) => deleteHandler(item)}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='deleteIcon_avt'>
                                <FaRegTrashCan color='red' />
                            </span>
                        </span>
                    </div> : <></>}
                    {/* } */}
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    return (
        <div className="__profilCmp_main">
            <ButtonHeading
                title={"Vehicle Document Type"}
                onClick={toggleVehicleDocTypeModel}
                buttonTitle="Vehicle Document Type"
                // buttonTitle={settingChildVehicleGrp?.create === 1 && "Add Vehicle Group"}
                showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={true}
            />

            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(vehicleDocList?.length > 0 ? vehicleDocList : [])}
                    isLoading={loading}
                />

                {vehicleDocList?.length ? <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div> : <></>}
            </div>

            {
                vehicleDocTypeModel
                && (
                    <AddEditVehicleDocTypeModel {...vehicleDocTypeModelProps} />
                )
            }

            {
                isDelete?.company_id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
            >
                {showFilterModal &&
                    <MastersFilterModal
                        isOpen={showFilterModal}
                        onClose={() => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                    />
                }
            </div>
            <div className={showFilterModal ? 'offBack_drop' : ''}></div>

        </div>
    )
}

export default VehicleDocumentType